export default __webpack_public_path__ + "static/media/funds__investments-deal-room.af4eab37.png";